'use client';

import type { ComponentPropsWithoutRef } from 'react';
import { useState } from 'react';
import classNames from 'classnames';

import { ShowAllToggle } from '@/components/atoms/ShowAllToggle';
import styles from './index.module.scss';
import { RepairDetail } from './components/RepairDetail';

export interface RepairsListProps extends ComponentPropsWithoutRef<'div'> {
  readonly className?: string;
}

const serviceNames = [
  'Full Service',
  'Interim Service',
  'General repairs',
  'Oil Change',
  'Brake Inspection',
  'Engine Diagnostic',
  'Tire Rotation',
  'AC Repair',
  'Transmission Service',
  'Wheel Alignment',
  'Battery Replacement',
];

export function RepairsList({ className }: RepairsListProps): JSX.Element {
  const [showAll, setShowAll] = useState(false);

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  return (
    <div className={classNames(styles.component, className, styles.RepairsList)}>
      <div className={classNames(styles.servicesContainer, showAll ? styles.Visible : styles.Hidden)}>
        {serviceNames.map((serviceName) => (
          <RepairDetail key={serviceName} serviceName={serviceName} />
        ))}
      </div>
      <ShowAllToggle
        showAll={showAll}
        toggleShowAll={toggleShowAll}
        showMoreText="Show all repairs"
        showLessText="Show less"
        styleType="labelStyle"
      />
    </div>
  );
}

RepairsList.displayName = 'RepairsList';
